import { render } from "./TvmFullFillmentText.vue?vue&type=template&id=15a2a784&scoped=true"
import script from "./TvmFullFillmentText.js?vue&type=script&lang=js&external"
export * from "./TvmFullFillmentText.js?vue&type=script&lang=js&external"

import "./TvmFullFillmentText.vue?vue&type=style&index=0&id=15a2a784&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15a2a784"],['__file',"src/Components/ChatWidget/TvmFullFillmentText/TvmFullFillmentText.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "15a2a784"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('15a2a784', __exports__)) {
    api.reload('15a2a784', __exports__)
  }
  
  module.hot.accept("./TvmFullFillmentText.vue?vue&type=template&id=15a2a784&scoped=true", () => {
    api.rerender('15a2a784', render)
  })

}


export default __exports__